<div class="wrap-spinner">
  <mat-spinner [diameter]="diameter"></mat-spinner>
</div>
